import { ProductStore } from '@/model';
import {
  GetProductStoreByIdResponse,
  GetProductStoreItemResponse,
  GetProductStoreResponse,
  PostProductStoreResponse,
  PutProductStoreResponse,
} from '@/services/response/product-store';

export class ProductStoreConverter {
  static toDomainFromGetItemResponse(response: GetProductStoreItemResponse): ProductStore {
    return {
      source_url: response.source_url,
      updated_at: response.updated_at,
      image_url: response.image_url,
      created_at: response.created_at,
      title: response.title,
      published_at: response.published_at,
      uuid: response.uuid,
      status: response.status,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      partner_name: response.partner_name,
      partner_uuid: response.partner_uuid,
      price: response.price,
    };
  }

  static toDomainFromPaginatedResponse(response: GetProductStoreResponse): ProductStore[] {
    return response.data.map(ProductStoreConverter.toDomainFromGetItemResponse);
  }

  static toDomainFromByIdResponse(response: GetProductStoreByIdResponse): ProductStore {
    return {
      source_url: response.source_url,
      updated_at: response.updated_at,
      image_url: response.image_url,
      created_at: response.created_at,
      title: response.title,
      published_at: response.published_at,
      uuid: response.uuid,
      status: response.status,
      team_uuid: response.team_uuid,
      team_name: response.team_name,
      team_image: response.team_image,
      partner_name: response.partner_name,
      partner_uuid: response.partner_uuid,
      price: response.price,
    };
  }

  static toDomainFromPostResponse(response: PostProductStoreResponse): ProductStore {
    return {
      source_url: response.source_url,
      updated_at: response.updated_at,
      image_url: response.image_url,
      created_at: response.created_at,
      title: response.title,
      published_at: response.published_at,
      uuid: response.uuid,
      status: response.status,
      partner_name: response.partner_name,
      partner_uuid: response.partner_uuid,
      price: response.price,
    };
  }

  static toDomainFromPutResponse(response: PutProductStoreResponse): ProductStore {
    return {
      source_url: response.source_url,
      updated_at: response.updated_at,
      image_url: response.image_url,
      created_at: response.created_at,
      title: response.title,
      published_at: response.published_at,
      uuid: response.uuid,
      status: response.status,
      partner_name: response.partner_name,
      partner_uuid: response.partner_uuid,
      price: response.price,
    };
  }
}
